export const UPDATE_API_CALL_STATUS = "UPDATE_API_CALL_STATUS";
export const CLEAR_API_CALL_STATUS = "CLEAR_API_CALL_STATUS";

type Status = "pending" | "success" | "error" | "final" | "already_paired";
export interface ApiStatus {
  status: Status;
  module: string;
  msg?: string;
  noOfAttempts?: number;
}
export interface ApiCallStatus {
  [x: string]: any;
  [index: number]: { module: string; status: any; msg?: string };
}
export enum appActions {
  UPDATE_API_CALL_STATUS = "UPDATE_API_CALL_STATUS",
  CLEAR_API_CALL_STATUS = "CLEAR_API_CALL_STATUS",
}

interface updateApiCallStatus {
  type: appActions.UPDATE_API_CALL_STATUS | appActions.CLEAR_API_CALL_STATUS;
  payload: ApiStatus;
}

export type AppActionTypes = updateApiCallStatus;
